import { useEffect } from 'react';

/**
 * Ask before the tab closes while `active`.
 *
 * An import is four to six minutes of generation, and the screen showing its progress is the only
 * place its result and its warnings (missing points, dropped images, a renamed slug) are shown.
 * The draft is saved server-side either way, but closing the tab mid-run threw away everything the
 * operator needed to review it, with no prompt at all. Browsers show their own wording; the
 * message is ignored by all of them and set only because some still require a value.
 */
export function useBeforeUnloadWhile(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = 'A guide import is still running.';
      return e.returnValue;
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [active]);
}
